import React from 'react';
import styled from 'styled-components';
import { FiCalendar } from 'react-icons/fi';

const Container = styled.div`
  padding: ${props => props.theme.spacing.xl};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.md};
  margin-bottom: ${props => props.theme.spacing.xl};
`;

const Title = styled.h1`
  font-size: ${props => props.theme.fontSizes.xxl};
  font-weight: 700;
  color: ${props => props.theme.colors.dark};
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: ${props => props.theme.colors.primary};
  border-radius: ${props => props.theme.borders.radius.lg};
  color: white;
  
  svg {
    font-size: 24px;
  }
`;

const PlaceholderContent = styled.div`
  background: white;
  border-radius: ${props => props.theme.borders.radius.lg};
  padding: ${props => props.theme.spacing.xxl};
  text-align: center;
  box-shadow: ${props => props.theme.shadows.sm};
  border: 1px solid ${props => props.theme.colors.gray[200]};
`;

const PlaceholderText = styled.p`
  font-size: ${props => props.theme.fontSizes.lg};
  color: ${props => props.theme.colors.gray[600]};
  margin-bottom: ${props => props.theme.spacing.lg};
`;

const ComingSoonBadge = styled.div`
  display: inline-block;
  background: ${props => props.theme.colors.primary};
  color: white;
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.lg};
  border-radius: ${props => props.theme.borders.radius.xl};
  font-weight: 600;
  font-size: ${props => props.theme.fontSizes.sm};
`;

const BuildMyEvent = () => {
  return (
    <Container>
      <Header>
        <IconWrapper>
          <FiCalendar />
        </IconWrapper>
        <Title>Build My Event</Title>
      </Header>
      
      <PlaceholderContent>
        <PlaceholderText>
          Event management functionality will be added here.
        </PlaceholderText>
        <ComingSoonBadge>
          Coming Soon
        </ComingSoonBadge>
      </PlaceholderContent>
    </Container>
  );
};

export default BuildMyEvent;
